import React from 'react';
import './TwoEqualDivision.less';

interface TwoEqualDivisionState {

}

interface TwoEqualDivisionPropType {
    prefixCls?: string;
    floorId: any;
    floorTemplate: any[];
    onFloorClick: Function;
}

class TwoEqualDivision extends React.Component<TwoEqualDivisionPropType, TwoEqualDivisionState> {
    static defaultProps = {
        prefixCls: 'twoEqualDivision',
    };

    render() {
        const {prefixCls, floorId, floorTemplate, onFloorClick} = this.props;
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}imgBox leftBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl);
                }}>
                    <img src={floorTemplate[0].moduleImgUrl} alt=""/>
                </div>
                <div className={`${prefixCls}imgBox rightBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[1].moduleName, floorTemplate[1].moduleUrlType, floorTemplate[1].moduleUrl);
                }}>
                    <img src={floorTemplate[1].moduleImgUrl} alt=""/>
                </div>
            </div>
        );
    }
}

export default TwoEqualDivision;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/twoEqualDivision/TwoEqualDivision.tsx